import { render, staticRenderFns } from "./AddColBeforeIcon.vue?vue&type=template&id=72e08340"
import script from "./AddColBeforeIcon.vue?vue&type=script&lang=js"
export * from "./AddColBeforeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports